/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Namelabel1Inputs */

const zh_course_namelabel1 = /** @type {(inputs: Course_Namelabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程名称`)
};

const en_course_namelabel1 = /** @type {(inputs: Course_Namelabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course Name`)
};

const es_course_namelabel1 = /** @type {(inputs: Course_Namelabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del curso`)
};

/**
* | output |
* | --- |
* | "Course Name" |
*
* @param {Course_Namelabel1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_namelabel1 = /** @type {((inputs?: Course_Namelabel1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Namelabel1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_namelabel1(inputs)
	if (locale === "en") return en_course_namelabel1(inputs)
	return es_course_namelabel1(inputs)
});
export { course_namelabel1 as "course_nameLabel" }